var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMajesticonsCommentLine1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 4.83398H6.25C5.58696 4.83398 4.95107 5.0886 4.48223 5.54181C4.01339 5.99502 3.75 6.60971 3.75 7.25065V25.3756L8.08375 22.234C8.51649 21.9202 9.04282 21.7506 9.58375 21.7506H23.75C24.413 21.7506 25.0489 21.496 25.5178 21.0428C25.9866 20.5896 26.25 19.9749 26.25 19.334V7.25065C26.25 6.60971 25.9866 5.99502 25.5178 5.54181C25.0489 5.0886 24.413 4.83398 23.75 4.83398Z",
    stroke: "#666666",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMajesticonsCommentLine1);
export default __webpack_public_path__ + "static/media/majesticons_comment-line1.fe4f87aa5c4301c69bfa0ccce1ab19d6.svg";
export { ForwardRef as ReactComponent };